import script from "./PaymentHistoryView.vue?vue&type=script&setup=true&lang=js"
export * from "./PaymentHistoryView.vue?vue&type=script&setup=true&lang=js"

import "./PaymentHistoryView.vue?vue&type=style&index=0&id=c7c27114&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c7c27114"]])

export default __exports__